export const environment = {
    production: true,
    CAPTCHA_KEY:"6Lfqd6whAAAAAA_t6J0sTi3IlhGTx3UudbuTIXSn",
    apiURL: 'https://portfolio.apis-ds.com',
};